import { useRef, useState, useEffect } from 'react';
import { Box, Flex } from "@chakra-ui/react";
import { detectEmbedType, extractIframeSrc } from '../../../global/helpers/global-helpers';




export default function DisplayCodeEmbeddedTile({ code }) {
  const containerRef = useRef(null);
  
  const [displaySrc, setDisplaySrc] = useState("")
  const scriptAddedRef = useRef(false);
  const timeoutRef = useRef(null);

  const [error, setError] = useState('');

  useEffect(() => {
    if (code && containerRef.current) {

      if (containerRef.current && !scriptAddedRef.current) {
        // setIsLoading(true)
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
          // setIsLoading(false);
          setError('Failed to load content. The provider might be unavailable.');
        }, 10000); // Timeout duration in milliseconds (10 seconds)
  
        const embedType = code ? detectEmbedType(code) : "";
        // Clear the container
        containerRef.current.innerHTML = '';
  
        // Inject the HTML content
        containerRef.current.innerHTML = code;
      
        if (embedType === 'script') {
        // Handle script tags
        const scripts = containerRef.current.getElementsByTagName('script');
        Array.from(scripts).forEach((script) => {
          const newScript = document.createElement('script');
          newScript.async = true;
  
          if (script.src) {
            // Cache busting
            newScript.src = `${script.src}?cache_buster=${new Date().getTime()}`;
          } else {
            // Inline script
            newScript.innerHTML = script.innerHTML;
          }
     
          containerRef.current.appendChild(newScript); // Append the new script
          script.remove(); // Remove the old script

    
          scriptAddedRef.current = true; // Mark script as added


          if (containerRef.current) {
            // setDisplaySrc(iframeSrc)
            clearTimeout(timeoutRef.current);
          }
        });
      }  else if (embedType === 'iframe') {
        // setShowEmptyState(false);
        const iframeSrc = extractIframeSrc(code)
  
        if (iframeSrc) {
          setDisplaySrc(iframeSrc)
          clearTimeout(timeoutRef.current);
        }
     
      }
      // setIsLoading(false)
      }

    }
  
  }, [code]);


  if (error) {
    return (
      <Box fontSize='0.875em' color='gray.500'>
        Failed to load content. The provider might be unavailable.
      </Box>
    )
  } else {
    if (displaySrc) {
      return (
        <Flex key={code} direction='column'>
          {/* <Box fontSize='1.5em' fontWeight='500' lineHeight='1.5em'>Text</Box> */}
          <Box
          h="100%" 
          minH='20em'
          mt='1em' 
          bg='white'
          position='relative'
          >
  
            <iframe
              className="tile-container-loom-video__white-background loader-img iframe-round"
              title="Embedded Content"
              width='100%'
              // minH='20em'
              height='100%'
              src={displaySrc}
              webkitallowfullscreen='true'
              mozallowfullscreen='true'
              allowFullScreen
            />
          </Box>
        </Flex>
  
      );
  
    } else {
      return (
        <Box key={code} h="100%" minH='20em' bg='gray.100'>
          <div ref={containerRef} style={{ width: '100%', height: '100%' }} />
        </Box>
      );
    }
    
  }
 
}



